export default {"src":"/_next/static/media/instagram-icon.0bc55009.svg","height":20,"width":20};